module.exports = __webpack_public_path__ + "static/media/gastronomy-restaurants.c3399c08.jpg";